import React, { useCallback } from 'react';
import { $location } from '@umu/umu-dom';

interface IProps {
    url?: string;
}
export const QrGenerator = (props: IProps) => {
    const url = props.url || $location.href;
    const imgRef = useCallback((node: HTMLDivElement) => {
        if (node) {
            node.innerHTML = '';
            // tslint:disable-next-line:no-unused-expression
            new QRCode(node, {
                text: url,
            });
        }
    }, [url]);
    return (
        <div className="img" ref={imgRef}></div>
    );
};
